"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isPaginationStepHidden = void 0;
var _constants = require("../constants");
const isPaginationStepHidden = ({
  slidesCount,
  currentSlide,
  maxVisibleItems = _constants.MAX_VISIBLE_PAGINATION_ITEMS,
  slideIndex
}) => slidesCount > maxVisibleItems && (slideIndex < currentSlide - 2 || slideIndex > currentSlide + 2);
exports.isPaginationStepHidden = isPaginationStepHidden;
